import {
    apiRequest,
    mappingPegawaiCreate, 
    mappingPegawaiUpdate,
    mappingPegawaiEmployeeList,
    mappingPegawaiUserList
} from "../../../../../../services/adapters/master/refMesinAbsenMappingPegawaiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", mappingPegawaiCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingPegawaiUpdate, {
            body: query
        }, true)
    }
    
    fetchEmployeeList = async (query, cancelToken) => {
        return await apiRequest("get", mappingPegawaiEmployeeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchUserList = async (query, cancelToken) => {
        return await apiRequest("get", mappingPegawaiUserList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository